const dynamicCardWithFiltersApp = Vue.createApp({
    data() {
        var safeFeaturedWebinarSku = typeof featuredWebinarSku !== 'undefined' ? featuredWebinarSku : null;
        return {
            featuredWebinarSku: safeFeaturedWebinarSku,
            webinars: (webinars || []).filter(w => !safeFeaturedWebinarSku || w.sku !== safeFeaturedWebinarSku),
            webinarSpeakers: webinarSpeakers || {},
            webinarPage: 1,
            webinarPerPage: 6,
            webinarPages: [],
            totalNumberofWebinarPages: 0,
            selectedDelivery: [],
            selectedTopics: [],
            selectedFeatures: [],
            selectedRecertCredits: [],
            selectedRegions: [],
            isApplyingFiltersFromUrl: false,
            keyTopics: [
                'Total Rewards',
                'Employee Compensation',
                'Executive Compensation',
                'Sales Compensation',
                'Employee Benefits',
                'Well-being',
                'Employee Recognition',
                'Career Growth'
            ],
            featureMap: {
                'membersOnly': { label: 'Member Only', check: (w) => w.member_Only__c || w.affiliate_Only__c }
            },
            recertCreditMap: {
                'benefits': { label: 'Benefits', check: (w) => parseFloat(w.benefits_Credit__c) > 0 },
                'compensation': { label: 'Compensation', check: (w) => parseFloat(w.compensation_Credit__c) > 0 },
                'general': { label: 'General', check: (w) => parseFloat(w.general_Credit__C) > 0 }
            },
            searchQuery: '',
            searchActive: false,
            searchLoading: false,
            searchMatchedIds: [],
            searchDebounceTimer: null,
            searchRequestSeq: 0,
            webinarCmsIds: typeof webinarCmsIds !== 'undefined' ? webinarCmsIds : {}
        }
    },
    methods: {
        setWebinarPages(webinars) {
            this.webinarPages = [];
            this.totalNumberofWebinarPages = Math.ceil(webinars.length / this.webinarPerPage);
            this.webinarPages = pagination(this.webinarPage, this.totalNumberofWebinarPages);
        },

        paginate(items, page, perPage) {
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            return items.slice(from, to);
        },

        resetPages() {
            this.webinarPage = 1;
        },

        onTopicChange() {
            this.resetPages();
        },

        onDeliveryChange() {
            this.resetPages();
        },

        onFeatureChange() {
            this.resetPages();
        },

        getSearchData() {
            clearTimeout(this.searchDebounceTimer);

            if (!this.searchQuery || this.searchQuery.trim() === '') {
                this.clearSearch();
                return;
            }

            this.searchActive = true;
            this.searchLoading = true;
            this.resetPages();

            const requestSeq = ++this.searchRequestSeq;

            let self = this;
            $.ajax({
                url: '/api/search/webinar-ids?q=' + encodeURIComponent(this.searchQuery.trim()),
                method: 'GET',
                success: function (ids) {
                    // Ignore out-of-order responses from earlier keystrokes.
                    if (requestSeq !== self.searchRequestSeq) return;
                    self.searchMatchedIds = ids || [];
                    self.searchLoading = false;
                },
                error: function () {
                    if (requestSeq !== self.searchRequestSeq) return;
                    self.searchMatchedIds = [];
                    self.searchLoading = false;
                }
            });
        },

        matchesSearch(webinar) {
            if (!this.searchMatchedIds.length) return false;

            const cmsId = (this.webinarCmsIds || {})[webinar.sku];
            return !!cmsId && this.searchMatchedIds.some(id => id.toLowerCase() === cmsId.toLowerCase());
        },

        clearSearch() {
            this.searchQuery = '';
            this.searchActive = false;
            this.searchLoading = false;
            this.searchMatchedIds = [];
            this.resetPages();
        },

        getSpeakers(sku) {
            return this.webinarSpeakers[sku] || [];
        },

        getSponsorInfo(webinar) {
            if (webinar.sponsorLogo && webinar.sponsorshipKind && webinar.sponsorshipKind.toLowerCase() !== 'none') {
                return {
                    text: webinar.sponsorshipKind,
                    logo: webinar.sponsorLogo
                };
            }
            return null;
        },

        handleImageError(event) {
            event.target.src = '/img/profile-default.svg';
            event.target.onerror = null;
        },

        sanitizeValue(val) {
            if (val === null || val === undefined) return '';
            return String(val).replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        },

        resetFilters() {
            this.selectedDelivery = [];
            this.selectedTopics = [];
            this.selectedFeatures = [];
            this.selectedRecertCredits = [];
            this.selectedRegions = [];

            document.querySelectorAll('input[name="delChannel"]').forEach(input => {
                input.checked = false;
            });
            document.querySelectorAll('input[name="topicFilter"]').forEach(input => {
                input.checked = false;
            });
            document.querySelectorAll('input[name="featureFilter"]').forEach(input => {
                input.checked = false;
            });
            document.querySelectorAll('input[name="recertCreditFilter"]').forEach(input => {
                input.checked = false;
            });
            document.querySelectorAll('input[name="regionFilter"]').forEach(input => {
                input.checked = false;
            });

            this.updateUrlWithFilters();
        },

        updateUrlWithFilters() {
            if (this.isApplyingFiltersFromUrl) return;

            let params = new URLSearchParams(window.location.search || '');

            if (this.selectedDelivery.length > 0) {
                const sanitizedDelivery = this.selectedDelivery.map(d => this.sanitizeValue(d));
                params.set('delivery', sanitizedDelivery.join(' '));
            } else {
                params.delete('delivery');
            }

            if (this.selectedTopics.length > 0) {
                const sanitizedTopics = this.selectedTopics.map(t => this.sanitizeValue(t));
                params.set('topic', sanitizedTopics.join(' '));
            } else {
                params.delete('topic');
            }

            if (this.selectedFeatures.length > 0) {
                const sanitizedFeatures = this.selectedFeatures.map(f => this.sanitizeValue(f));
                params.set('features', sanitizedFeatures.join(' '));
            } else {
                params.delete('features');
            }

            if (this.selectedRecertCredits.length > 0) {
                params.set('recertCredits', this.selectedRecertCredits.join(' '));
            } else {
                params.delete('recertCredits');
            }

            if (this.selectedRegions.length > 0) {
                const sanitizedRegions = this.selectedRegions.map(r => this.sanitizeValue(r));
                params.set('region', sanitizedRegions.join(' '));
            } else {
                params.delete('region');
            }

            let newUrl = window.location.pathname;
            const query = params.toString();
            if (query.length > 0) {
                newUrl += '?' + query;
            }

            if (window.location.hash) {
                newUrl += window.location.hash;
            }

            window.history.pushState(null, '', newUrl);
        },

        applyFiltersFromUrl() {
            this.isApplyingFiltersFromUrl = true;
            const params = new URLSearchParams(window.location.search);

            let paramMap = {};
            for (const [key, value] of params.entries()) {
                paramMap[key.toLowerCase()] = value;
            }

            const delivery = paramMap['delivery'];
            if (delivery) {
                delivery.split(' ').forEach(val => {
                    document.querySelectorAll('input[name="delChannel"]').forEach(input => {
                        if (this.sanitizeValue(input.value) === val.toLowerCase()) {
                            input.checked = true;
                            if (!this.selectedDelivery.includes(input.value)) {
                                this.selectedDelivery.push(input.value);
                            }
                        }
                    });
                });
            }

            const topic = paramMap['topic'];
            if (topic) {
                topic.split(' ').forEach(val => {
                    document.querySelectorAll('input[name="topicFilter"]').forEach(input => {
                        if (this.sanitizeValue(input.value) === val.toLowerCase()) {
                            input.checked = true;
                            if (!this.selectedTopics.includes(input.value)) {
                                this.selectedTopics.push(input.value);
                            }
                        }
                    });
                });
            }

            const features = paramMap['features'];
            if (features) {
                features.split(' ').forEach(val => {
                    document.querySelectorAll('input[name="featureFilter"]').forEach(input => {
                        if (this.sanitizeValue(input.value) === val.toLowerCase()) {
                            input.checked = true;
                            if (!this.selectedFeatures.includes(input.value)) {
                                this.selectedFeatures.push(input.value);
                            }
                        }
                    });
                });
            }

            const recertCredits = paramMap['recertcredits'];
            if (recertCredits) {
                recertCredits.split(' ').forEach(val => {
                    document.querySelectorAll('input[name="recertCreditFilter"]').forEach(input => {
                        if (input.value === val) {
                            input.checked = true;
                            if (!this.selectedRecertCredits.includes(input.value)) {
                                this.selectedRecertCredits.push(input.value);
                            }
                        }
                    });
                });
            }

            const region = paramMap['region'];
            if (region) {
                region.split(' ').forEach(val => {
                    document.querySelectorAll('input[name="regionFilter"]').forEach(input => {
                        if (this.sanitizeValue(input.value) === val.toLowerCase()) {
                            input.checked = true;
                            if (!this.selectedRegions.includes(input.value)) {
                                this.selectedRegions.push(input.value);
                            }
                        }
                    });
                });
            }

            this.updateUrlWithFilters();
            this.isApplyingFiltersFromUrl = false;
        }
    },
    computed: {
        filtersApplied() {
            return this.selectedDelivery.length > 0 || this.selectedTopics.length > 0 || this.selectedFeatures.length > 0 || this.selectedRecertCredits.length > 0 || this.selectedRegions.length > 0;
        },

        // Webinars filtered by search only (no sidebar filters).
        // This is the base pool from which reactive filter options are derived.
        searchBaseWebinars() {
            if (!this.searchActive || this.searchLoading || !this.searchMatchedIds.length) {
                return this.webinars;
            }
            const self = this;
            return this.webinars.filter(function (w) {
                const cmsId = (self.webinarCmsIds || {})[w.sku];
                return !!cmsId && self.searchMatchedIds.some(id => id.toLowerCase() === cmsId.toLowerCase());
            });
        },

        topics() {
            var webinarTopic = [];
            this.searchBaseWebinars.forEach(function (webinar) {
                webinarTopic = webinarTopic.concat(webinar.practiceArea);
            });
            return webinarTopic.filter((item, i, ar) => ar.indexOf(item) === i);
        },

        availableFeatures() {
            let features = [];
            const base = this.searchBaseWebinars;

            Object.keys(this.featureMap).forEach(featureKey => {
                const featureConfig = this.featureMap[featureKey];
                if (base.some(webinar => featureConfig.check(webinar))) {
                    features.push({ key: featureKey, value: featureKey, label: featureConfig.label });
                }
            });

            base.map(x => x.pbL_TYPE)
                .filter((v, i, arr) => v && arr.indexOf(v) === i)
                .forEach(pblType => {
                    features.push({
                        key: 'pblType_' + this.sanitizeValue(pblType),
                        value: pblType,
                        label: pblType,
                        isPblType: true,
                        pblTypeValue: pblType
                    });
                });

            return features;
        },

        availableRecertCredits() {
            let recertCredits = [];
            const base = this.searchBaseWebinars;

            Object.keys(this.recertCreditMap).forEach(key => {
                const config = this.recertCreditMap[key];
                if (base.some(webinar => config.check(webinar))) {
                    recertCredits.push({ key: key, value: key, label: config.label });
                }
            });

            return recertCredits;
        },

        availableRegions() {
            const regionsInData = new Set();
            let hasOthers = false;

            this.searchBaseWebinars.forEach(w => {
                const region = w.region__c && w.region__c.trim() ? w.region__c.trim() : null;
                if (region) {
                    regionsInData.add(region);
                } else {
                    hasOthers = true;
                }
            });

            const sorted = Array.from(regionsInData).sort((a, b) => a.localeCompare(b));
            if (hasOthers) {
                sorted.push('Others');
            }
            return sorted;
        },

        availableTopics() {
            let sortedTopics = [];
            let otherTopics = [];

            this.topics.forEach(topic => {
                if (this.keyTopics && this.keyTopics.includes(topic)) {
                    sortedTopics.push(topic);
                } else {
                    otherTopics.push(topic);
                }
            });

            if (otherTopics.length > 0) {
                sortedTopics.push('Other');
            }

            return sortedTopics;
        },

        filteredWebinars() {
            var filteredWebinars_all = this.webinars.filter(function (item) {
                return (
                    (!this.searchActive || (!this.searchLoading && this.matchesSearch(item)))
                    &&
                    (this.selectedDelivery.length === 0 || this.selectedDelivery.some(i => item.productType.includes(i)))
                    &&
                    (this.selectedTopics.length === 0 || this.selectedTopics.some(topic => {
                        if (topic === 'Other') {
                            return item.practiceArea.some(pa => !this.keyTopics.includes(pa));
                        }
                        return item.practiceArea.includes(topic);
                    }))
                    &&
                    (this.selectedFeatures.length === 0 || this.selectedFeatures.some(feature => {
                        const featureObj = this.availableFeatures.find(f => f.value === feature);
                        if (featureObj && featureObj.isPblType) {
                            return item.pbL_TYPE === featureObj.pblTypeValue;
                        }

                        const featureConfig = this.featureMap[feature];
                        return featureConfig && featureConfig.check(item);
                    }))
                    &&
                    (this.selectedRecertCredits.length === 0 || this.selectedRecertCredits.some(credit => {
                        const creditConfig = this.recertCreditMap[credit];
                        return creditConfig && creditConfig.check(item);
                    }))
                    &&
                    (this.selectedRegions.length === 0 || this.selectedRegions.some(region => {
                        const itemRegion = item.region__c && item.region__c.trim() ? item.region__c.trim() : 'Others';
                        return itemRegion === region;
                    }))
                );
            }, this);

            var live_wbs = [];
            var on_demand_wbs = [];
            filteredWebinars_all.map(function (item) {
                if (item.productType.some(x => x.toLowerCase() == 'on demand')) {
                    on_demand_wbs.push(item);
                }
                else {
                    live_wbs.push(item);
                }
                return item;
            });

            live_wbs.sort(function (a, b) {
                return Date.parse(new Date(a.startDate)) - Date.parse(new Date(b.startDate));
            });
            on_demand_wbs.sort(function (a, b) {
                return Date.parse(new Date(b.endDate)) - Date.parse(new Date(a.endDate));
            });

            return live_wbs.concat(on_demand_wbs);
        },

        displayedWebinars() {
            this.setWebinarPages(this.filteredWebinars);
            return this.paginate(this.filteredWebinars, this.webinarPage, this.webinarPerPage);
        }
    },

    watch: {
        searchQuery() {
            // Search-as-you-type: debounce keystrokes; Enter/icon still search immediately via getSearchData.
            clearTimeout(this.searchDebounceTimer);

            if (!this.searchQuery || this.searchQuery.trim() === '') {
                this.clearSearch();
                return;
            }

            this.searchDebounceTimer = setTimeout(() => this.getSearchData(), 350);
        },

        availableTopics(newTopics) {
            if (this.selectedTopics.length > 0) {
                this.selectedTopics = this.selectedTopics.filter(t => newTopics.includes(t));
            }
        },
        availableFeatures(newFeatures) {
            if (this.selectedFeatures.length > 0) {
                const available = new Set(newFeatures.map(f => f.value));
                this.selectedFeatures = this.selectedFeatures.filter(f => available.has(f));
            }
        },
        availableRecertCredits(newCredits) {
            if (this.selectedRecertCredits.length > 0) {
                const available = new Set(newCredits.map(c => c.value));
                this.selectedRecertCredits = this.selectedRecertCredits.filter(c => available.has(c));
            }
        },
        availableRegions(newRegions) {
            if (this.selectedRegions.length > 0) {
                const available = new Set(newRegions);
                this.selectedRegions = this.selectedRegions.filter(r => available.has(r));
            }
        },
        selectedRegions() {
            this.resetPages();
            if (!this.isApplyingFiltersFromUrl) {
                this.updateUrlWithFilters();
            }
            scrollOnPagination("dynamicCardWithFilters");
        },
        selectedDelivery() {
            this.resetPages();
            if (!this.isApplyingFiltersFromUrl) {
                this.updateUrlWithFilters();
            }
            scrollOnPagination("dynamicCardWithFilters");
        },
        selectedTopics() {
            this.resetPages();
            if (!this.isApplyingFiltersFromUrl) {
                this.updateUrlWithFilters();
            }
            scrollOnPagination("dynamicCardWithFilters");
        },
        selectedFeatures() {
            this.resetPages();
            if (!this.isApplyingFiltersFromUrl) {
                this.updateUrlWithFilters();
            }
            scrollOnPagination("dynamicCardWithFilters");
        },
        selectedRecertCredits() {
            this.resetPages();
            if (!this.isApplyingFiltersFromUrl) {
                this.updateUrlWithFilters();
            }
            scrollOnPagination("dynamicCardWithFilters");
        },
        webinarPage: function (val) {
            scrollOnPagination("dynamicCardWithFilters");
        }
    },

    created() {
    },

    mounted() {
        this.applyFiltersFromUrl();
    },

    filters: {
        trimWords(value) {
            return value.split(" ").splice(0, 20).join(" ") + '...';
        }
    }
});

const dynamicCardWithFiltersMountedApp = dynamicCardWithFiltersApp.mount('#dynamicCardWithFilters');
